import { apiService } from "./apiService";
import { IMatchResponse, IMatch, IMatchViewResponse, IRequestMatches } from "../types/match";
import { timestampToMoment } from "../utils/utils";
import { CasesService } from "./cases";

export const MatchesService = {
  get: (caseId: string, childId: string): Promise<IMatchResponse> => {
    return apiService.get(`/api/matches/${caseId}/${childId}`).then(res => {
      const { data } = res
      return res.status === 200 && data ? data as IMatchResponse : undefined
    }).then((match) => {
      if (match) {
        match.caseInfo.openDate = timestampToMoment(match.caseInfo.openDate);
        match.childInfo.images = CasesService.formatImagesFe(match.childInfo.images);
        match.childInfo.birthDate = match.childInfo.birthDate ? timestampToMoment(match.childInfo.birthDate) : null
        match.caseInfo.missingDate = timestampToMoment(match.caseInfo.missingDate);
      }
      return match as IMatchResponse
    })
  },
  getBiometrica: (matchId: string): Promise<IMatch> => {
    return apiService.get(`/api/matches/biometrica/${matchId}`).then(res => {
      const { data } = res
      return res.status === 200 && data ? data as IMatch : undefined;
    }).then((match) => match as IMatch)
  },
  getAllByAgency: (request: IRequestMatches): Promise<IMatchViewResponse> => {
    return apiService.post(`/api/matches/agency`, { request }).then(res => {
      const { data } = res;
      return data as IMatchViewResponse;
    }).then((matches) => {
      if (matches) {
        matches.matches.results.forEach(match => {
          match.date = match.date ? timestampToMoment(match.date) : null;
          match.openDate = match.openDate ? timestampToMoment(match.openDate) : null;
          match.images = match.images ? CasesService.formatImagesFe(match.images) : null;
          match.birthDate = match.birthDate ? timestampToMoment(match.birthDate) : null;
          match.missingDate = match.missingDate ? timestampToMoment(match.missingDate) : null;
        });
      }
      return matches as IMatchViewResponse
    })
  },
  deleteMatchById: (matchId: string) => {
    return apiService.delete(`/api/matches/${matchId}`);
  },
  getAllByCase: (caseId: string): Promise<IMatchResponse[]> => {
    return apiService.get(`/api/matches/${caseId}`).then(res => {
      const { data } = res;
      return res.status === 200 && data ? data as IMatchResponse[] : []
    }).then((matches) => {
      if (matches) {
        return matches.map(MatchesService.mapMatch) as IMatchResponse[];
      }
      return matches as IMatchResponse[]
    })
  },
  getAdhoc: (searchId: string): Promise<IMatch[]> => {
    return apiService.get(`/api/matches/adhoc/${searchId}`).then(res => {
      const { data: matches } = res
      if (matches) {
        return matches.map(MatchesService.mapMatch) as IMatch[];
      } else {
        return [] as IMatch[]
      }
    }).then((match) => match)
  },
  mapMatch: (match) => {
    if (match.caseInfo) {
      match.caseInfo.openDate = timestampToMoment(match.caseInfo.openDate);
      match.caseInfo.missingDate = timestampToMoment(match.caseInfo.missingDate);
    }
    if (match.childInfo) {
      match.childInfo.images = CasesService.formatImagesFe(match.childInfo.images);
      match.childInfo.birthDate = match.childInfo.birthDate ? timestampToMoment(match.childInfo.birthDate) : null
    }
    return match;
  }
}